// src/components/ServiceCard.jsx
import React from "react";
import "./ServiceCard.css";

function ServiceCard({ title, icon, onClick }) {
  return (
    <div
      className="accessory-card"
      onClick={onClick}
    >
      <div className="accessory-icon">
        {icon}
      </div>
      <div className="accessory-title">{title}</div>
    </div>
  );
}

export default ServiceCard;
